import { BraveBupAPI } from '@BUP/services/Axios';

export function useChangeMessageState() {
  const handleChangeMessageState = async (messageId, newState) => {
    try {
      await BraveBupAPI.put(`/comments/${messageId}`, {
        state: newState,
      });
    } catch (e) {
      throw e;
    }
  };

  return [handleChangeMessageState];
}
